import { writable } from 'svelte/store';

export const user = writable(null);

// export const books = {
// 	"1": {
// 		id: "1",
// 		name: "Harry Potter and the Sorcerer's Stone",
// 		author: "J.K. Rowling",
// 		image: "https://i.gr-assets.com/images/S/compressed.photo.goodreads.com/books/1474154022l/3._SX98_.jpg",
// 		desc: `Harry Potter's life is miserable. His parents are dead and he's stuck with his heartless relatives, who force him to live in a tiny closet under the stairs. But his fortune changes when he receives a letter that tells him the truth about himself: he's a wizard. A mysterious visitor rescues him from his relatives and takes him to his new home, Hogwarts School of Witchcraft and Wizardry.

// After a lifetime of bottling up his magical powers, Harry finally feels like a normal kid. But even within the Wizarding community, he is special. He is the boy who lived: the only person to have ever survived a killing curse inflicted by the evil Lord Voldemort, who launched a brutal takeover of the Wizarding world, only to vanish after failing to kill Harry.

// Though Harry's first year at Hogwarts is the best of his life, not everything is perfect. There is a dangerous secret object hidden within the castle walls, and Harry believes it's his responsibility to prevent it from falling into evil hands. But doing so will bring him into contact with forces more terrifying than he ever could have imagined.

// Full of sympathetic characters, wildly imaginative situations, and countless exciting details, the first installment in the series assembles an unforgettable magical world and sets the stage for many high-stakes adventures to come.`
// 	},

// 	"2": {
// 		id: "2",
// 		name: "Pride and Prejudice",
// 		author: "Jane Austen",
// 		image: "https://i.gr-assets.com/images/S/compressed.photo.goodreads.com/books/1320399351l/1885.jpg",
// 		desc: `Since its immediate success in 1813, Pride and Prejudice has remained one of the most popular novels in the English language. Jane Austen called this brilliant work "her own darling child" and its vivacious heroine, Elizabeth Bennet, "as delightful a creature as ever appeared in print." The romantic clash between the opinionated Elizabeth and her proud beau, Mr. Darcy, is a splendid performance of civilized sparring. And Jane Austen's radiant wit sparkles as her characters dance a delicate quadrille of flirtation and intrigue, making this book the most superb comedy of manners of Regency England.`
// 	},
// 	"3": {
// 		id: "3",
// 		name: "To Kill a Mockingbird",
// 		author: "Harper Lee",
// 		image: "https://i.gr-assets.com/images/S/compressed.photo.goodreads.com/books/1553383690l/2657.jpg",
// 		desc: `The unforgettable novel of a childhood in a sleepy Southern town and the crisis of conscience that rocked it, To Kill A Mockingbird became both an instant bestseller and a critical success when it was first published in 1960. It went on to win the Pulitzer Prize in 1961 and was later made into an Academy Award-winning film, also a classic. Compassionate, dramatic, and deeply moving, To Kill A Mockingbird takes readers to the roots of human behavior - to innocence and experience, kindness and cruelty, love and hatred, humor and pathos. Now with over 18 million copies in print and translated into forty languages, this regional story by a young Alabama woman claims universal appeal. Harper Lee always considered her book to be a simple love story. Today it is regarded as a masterpiece of American literature.`
// 	},
// 	"4": {
// 		id: "4",
// 		name: "The Great Gatsby",
// 		author: "F. Scott Fitzgerald",
// 		image: "https://i.gr-assets.com/images/S/compressed.photo.goodreads.com/books/1490528560l/4671._SY475_.jpg",
// 		desc: `Alternate Cover Edition ISBN: 0743273567 (ISBN13: 9780743273565) The Great Gatsby, F. Scott Fitzgerald's third book, stands as the supreme achievement of his career. This exemplary novel of the Jazz Age has been acclaimed by generations of readers. The story is of the fabulously wealthy Jay Gatsby and his new love for the beautiful Daisy Buchanan, of lavish parties on Long Island at a time when The New York Times noted "gin was the national drink and sex the national obsession," it is an exquisitely crafted tale of America in the 1920s. The Great Gatsby is one of the great classics of twentieth-century literature.`
// 	},
// 	"5": {
// 		id: "5",
// 		name: "Jane Eyre",
// 		author: "Charlotte Brontë",
// 		image: "https://i.gr-assets.com/images/S/compressed.photo.goodreads.com/books/1557343311l/10210._SY475_.jpg",
// 		desc: `Clicca qui per l'edizione "Storie senza tempo". Orphaned as a child, Jane has felt an outcast her whole young life. Her courage is tested once again when she arrives at Thornfield Hall, where she has been hired by the brooding, proud Edward Rochester to care for his ward Adèle. Jane finds herself drawn to his troubled yet kind spirit. She falls in love. Hard. But there is a terrifying secret inside the gloomy, forbidding Thornfield Hall. Is Rochester hiding from Jane? Will Jane be left heartbroken and exiled once again?`
// 	},
// 	"6": {
// 		id: "6",
// 		name: "1984",
// 		author: "George Orwell",
// 		image: "https://i.gr-assets.com/images/S/compressed.photo.goodreads.com/books/1532714506l/40961427._SX318_.jpg",
// 		desc: `Among the seminal texts of the 20th century, Nineteen Eighty-Four is a rare work that grows more haunting as its futuristic purgatory becomes more real. Published in 1949, the book offers political satirist George Orwell's nightmarish vision of a totalitarian, bureaucratic world and one poor stiff's attempt to find individuality. The brilliance of the novel is Orwell's prescience of modern life—the ubiquity of television, the distortion of the language—and his ability to construct such a thorough version of hell. Required reading for students since it was published, it ranks among the most terrifying novels ever written. `
// 	},
// };
export const genres = [
	// "Art",
	"Biography",
	// "Business",
	// "Chick Lit",
	"Children's",
	// "Christian",
	"Classics",
	// "Comics",
	// "Contemporary",
	// "Cookbooks",
	"Crime",
	// "Ebooks",
	// "Fantasy",
	"Fiction",
	// "Gay and Lesbian",
	// "Graphic Novels",
	// "Historical Fiction",
	"History",
	// "Horror",
	// "Humor and Comedy",
	// "Manga",
	// "Memoir",
	// "Music",
	// "Mystery",
	"Nonfiction",
	// "Paranormal",
	"Philosophy",
	// "Poetry",
	// "Psychology",
	// "Religion",
	// "Romance",
	// "Science",
	"Science Fiction",
	"Self Help",
	// "Suspense",
	// "Spirituality",
	// "Sports",
	"Thriller",
	// "Travel",
	"Young Adult",
];

export const books = [
  {
    "available": true,
    "name": "Pride and Prejudice",
    "name_link": "https://www.goodreads.com/shelf/show/classics/book/show/1885.Pride_and_Prejudice",
    "image": "https://i.gr-assets.com/images/S/compressed.photo.goodreads.com/books/1320399351l/1885._SY75_.jpg",
    "author": "Jane Austen",
    "author_link": "https://www.goodreads.com/author/show/1265.Jane_Austen"
  },
  {
    "available": true,
    "name": "To Kill a Mockingbird",
    "name_link": "https://www.goodreads.com/shelf/show/classics/book/show/2657.To_Kill_a_Mockingbird",
    "image": "https://i.gr-assets.com/images/S/compressed.photo.goodreads.com/books/1553383690l/2657._SY75_.jpg",
    "author": "Harper Lee",
    "author_link": "https://www.goodreads.com/author/show/1825.Harper_Lee"
  },
  {
    "available": true,
    "name": "The Great Gatsby",
    "name_link": "https://www.goodreads.com/shelf/show/classics/book/show/4671.The_Great_Gatsby",
    "image": "https://i.gr-assets.com/images/S/compressed.photo.goodreads.com/books/1490528560l/4671._SY75_.jpg",
    "author": "F. Scott Fitzgerald",
    "author_link": "https://www.goodreads.com/author/show/3190.F_Scott_Fitzgerald"
  },
  {
    "available": true,
    "name": "Jane Eyre",
    "name_link": "https://www.goodreads.com/shelf/show/classics/book/show/10210.Jane_Eyre",
    "image": "https://i.gr-assets.com/images/S/compressed.photo.goodreads.com/books/1557343311l/10210._SY75_.jpg",
    "author": "Charlotte Brontë",
    "author_link": "https://www.goodreads.com/author/show/1036615.Charlotte_Bront_"
  },
  {
    "available": true,
    "name": "1984",
    "name_link": "https://www.goodreads.com/shelf/show/classics/book/show/40961427-1984",
    "image": "https://i.gr-assets.com/images/S/compressed.photo.goodreads.com/books/1532714506l/40961427._SX50_.jpg",
    "author": "George Orwell",
    "author_link": "https://www.goodreads.com/author/show/3706.George_Orwell"
  },
  {
    "available": true,
    "name": "Wuthering Heights",
    "name_link": "https://www.goodreads.com/shelf/show/classics/book/show/6185.Wuthering_Heights",
    "image": "https://i.gr-assets.com/images/S/compressed.photo.goodreads.com/books/1587655304l/6185._SY75_.jpg",
    "author": "Emily Brontë",
    "author_link": "https://www.goodreads.com/author/show/4191.Emily_Bront_"
  },
  {
    "available": true,
    "name": "Animal Farm",
    "name_link": "https://www.goodreads.com/shelf/show/classics/book/show/170448.Animal_Farm",
    "image": "https://i.gr-assets.com/images/S/compressed.photo.goodreads.com/books/1325861570l/170448._SY75_.jpg",
    "author": "George Orwell",
    "author_link": "https://www.goodreads.com/author/show/3706.George_Orwell"
  },
  {
    "available": true,
    "name": "The Catcher in the Rye",
    "name_link": "https://www.goodreads.com/shelf/show/classics/book/show/5107.The_Catcher_in_the_Rye",
    "image": "https://i.gr-assets.com/images/S/compressed.photo.goodreads.com/books/1398034300l/5107._SY75_.jpg",
    "author": "J.D. Salinger",
    "author_link": "https://www.goodreads.com/author/show/819789.J_D_Salinger"
  },
  {
    "available": true,
    "name": "Little Women",
    "name_link": "https://www.goodreads.com/shelf/show/classics/book/show/1934.Little_Women",
    "image": "https://i.gr-assets.com/images/S/compressed.photo.goodreads.com/books/1562690475l/1934._SY75_.jpg",
    "author": "Louisa May Alcott",
    "author_link": "https://www.goodreads.com/author/show/1315.Louisa_May_Alcott"
  },
  {
    "available": true,
    "name": "Frankenstein",
    "name_link": "https://www.goodreads.com/shelf/show/classics/book/show/35031085-frankenstein",
    "image": "https://i.gr-assets.com/images/S/compressed.photo.goodreads.com/books/1498841231l/35031085._SY75_.jpg",
    "author": "Mary Wollstonecraft Shelley",
    "author_link": "https://www.goodreads.com/author/show/11139.Mary_Wollstonecraft_Shelley"
  },


  {
    "available": true,
    "name": "Onnen pisaroita",
    "name_link": "https://haku.helmet.fi/iii/encore/record/C__Rb2426217?lang=fin",
    "image": "https://armas.btj.fi/request.php?id=f55f7189859e3777&pid=9789528108450&qtype=m&ftype=06",
    "author": "Rantanen, Katriina"
  },
  {
    "available": true,
    "name": "Teistä kaikista tämä",
    "name_link": "https://haku.helmet.fi/iii/encore/record/C__Rb2426129?lang=fin",
    "image": "https://armas.btj.fi/request.php?id=f55f7189859e3777&pid=9789522157935&qtype=m&ftype=06",
    "author": "Jäppilä, Leena"
  },
  {
    "available": true,
    "name": "Todellisesti, ja luonnollisella tavalla selitettyjä Kummitus-juttuja, kerroiltut tonttujen ja kummitusten uskomisen estäämiseksi",
    "name_link": "https://haku.helmet.fi/iii/encore/record/C__Rb2426127?lang=fin",
    "image": "https://armas.btj.fi/request.php?id=f55f7189859e3777&pid=9789527211571&qtype=m&ftype=06",
    "author": null
  },
  {
    "available": true,
    "name": "Kärpänen mustepullossa: venäjänkielisten kirjailijoiden novelleja",
    "name_link": "https://haku.helmet.fi/iii/encore/record/C__Rb2426125?lang=fin",
    "image": "https://armas.btj.fi/request.php?id=f55f7189859e3777&pid=9789526942407&qtype=m&ftype=06",
    "author": null
  },
  {
    "available": true,
    "name": "Pikku piika",
    "name_link": "https://haku.helmet.fi/iii/encore/record/C__Rb2425383?lang=fin",
    "image": "https://armas.btj.fi/request.php?id=f55f7189859e3777&pid=9789528021681&qtype=m&ftype=06",
    "author": "Haataja, Airi"
  },
  {
    "available": true,
    "name": "Veritorstai",
    "name_link": "https://haku.helmet.fi/iii/encore/record/C__Rb2425294?lang=fin",
    "image": "https://armas.btj.fi/request.php?id=f55f7189859e3777&pid=9789527349076&qtype=m&ftype=06",
    "author": "Katajamäki, Unto"
  },
  {
    "available": true,
    "name": "Olemattomien jumala",
    "name_link": "https://haku.helmet.fi/iii/encore/record/C__Rb2425016?lang=fin",
    "image": "https://armas.btj.fi/request.php?id=f55f7189859e3777&pid=9789526895390&qtype=m&ftype=06",
    "author": "Kuusenoksa, Anu"
  },
  {
    "available": true,
    "name": "Mistä tulen, minne menen",
    "name_link": "https://haku.helmet.fi/iii/encore/record/C__Rb2425012?lang=fin",
    "image": "https://armas.btj.fi/request.php?id=f55f7189859e3777&pid=9789527307090&qtype=m&ftype=06",
    "author": "Murto, Sinikka"
  },
  {
    "available": true,
    "name": "Puolesta ja vastaan: esseitä kirjoista ja aatteista",
    "name_link": "https://haku.helmet.fi/iii/encore/record/C__Rb2425008?lang=fin",
    "image": "https://armas.btj.fi/request.php?id=f55f7189859e3777&pid=9789525483291&qtype=m&ftype=06",
    "author": null
  },
  {
    "available": true,
    "name": "Vaihtuvat maisemat",
    "name_link": "https://haku.helmet.fi/iii/encore/record/C__Rb2424433?lang=fin",
    "image": "https://armas.btj.fi/request.php?id=f55f7189859e3777&pid=9789527342053&qtype=m&ftype=06",
    "author": "Wassenaar, Joop"
  },


  {
    "available": true,
    "name": "Suden hetki",
    "name_link": "https://haku.helmet.fi/iii/encore/record/C__Rb2413964?lang=fin",
    "image": "https://armas.btj.fi/request.php?id=f55f7189859e3777&pid=9789527105573&qtype=m&ftype=06",
    "author": "Maijala, Marika"
  },
  {
    "available": true,
    "name": "Kuka vei roskat?",
    "name_link": "https://haku.helmet.fi/iii/encore/record/C__Rb2413949?lang=fin",
    "image": "https://armas.btj.fi/request.php?id=f55f7189859e3777&pid=9789523413597&qtype=m&ftype=06",
    "author": "Sarja, Tiina"
  },
  {
    "available": true,
    "name": "Pienessäkin on potkua!",
    "name_link": "https://haku.helmet.fi/iii/encore/record/C__Rb2413938?lang=fin",
    "image": "https://armas.btj.fi/request.php?id=f55f7189859e3777&pid=9789523413535&qtype=m&ftype=06",
    "author": "Ljunggren, Magnus"
  },
  {
    "available": true,
    "name": "Maailman paras ritari",
    "name_link": "https://haku.helmet.fi/iii/encore/record/C__Rb2413937?lang=fin",
    "image": "https://armas.btj.fi/request.php?id=f55f7189859e3777&pid=9789523413528&qtype=m&ftype=06",
    "author": "Ljunggren, Magnus"
  },
  {
    "available": true,
    "name": "Kultainen miekka",
    "name_link": "https://haku.helmet.fi/iii/encore/record/C__Rb2413936?lang=fin",
    "image": "https://armas.btj.fi/request.php?id=f55f7189859e3777&pid=9789523413511&qtype=m&ftype=06",
    "author": "Ljunggren, Magnus"
  },
  {
    "available": true,
    "name": "Hirmuinen lohikäärme",
    "name_link": "https://haku.helmet.fi/iii/encore/record/C__Rb2413935?lang=fin",
    "image": "https://armas.btj.fi/request.php?id=f55f7189859e3777&pid=9789523413504&qtype=m&ftype=06",
    "author": "Ljunggren, Magnus"
  },
  {
    "available": true,
    "name": "Peppe potalla",
    "name_link": "https://haku.helmet.fi/iii/encore/record/C__Rb2413928?lang=fin",
    "image": "https://armas.btj.fi/request.php?id=f55f7189859e3777&pid=9789523413252&qtype=m&ftype=06",
    "author": "Lindman, Mervi"
  },
  {
    "available": true,
    "name": "Kolmikko metsäretkellä",
    "name_link": "https://haku.helmet.fi/iii/encore/record/C__Rb2413927?lang=fin",
    "image": "https://armas.btj.fi/request.php?id=f55f7189859e3777&pid=9789523413344&qtype=m&ftype=06",
    "author": "Nilsson Thore, Maria"
  },
  {
    "available": true,
    "name": "Kolmikko leikkii sisällä",
    "name_link": "https://haku.helmet.fi/iii/encore/record/C__Rb2413926?lang=fin",
    "image": "https://armas.btj.fi/request.php?id=f55f7189859e3777&pid=9789523413320&qtype=m&ftype=06",
    "author": "Nilsson Thore, Maria"
  },
  {
    "available": true,
    "name": "Kolmikko ulkoilee",
    "name_link": "https://haku.helmet.fi/iii/encore/record/C__Rb2413925?lang=fin",
    "image": "https://armas.btj.fi/request.php?id=f55f7189859e3777&pid=9789523413337&qtype=m&ftype=06",
    "author": "Nilsson Thore, Maria"
  },


  {
    "available": true,
    "name": "Harry Potter ja Azkabanin vanki",
    "name_link": "https://haku.helmet.fi/iii/encore/record/C__Rb2413925?lang=fin",
    "image": "https://armas.btj.fi/request.php?id=f55f7189859e3777&pid=9789520401849",
    "author": "Rowling, J.K."
  },
  {
    "available": false,
    "name": "Taru sormusten herrasta: Kaksi tornia",
    "name_link": "https://haku.helmet.fi/iii/encore/record/C__Rb2413925?lang=fin",
    "image": "https://armas.btj.fi/request.php?id=f55f7189859e3777&pid=9789510397046",
    "author": "Tolkien, J. R. R."
  },
  {
    "available": true,
    "name": "A Dance with Dragons",
    "name_link": "https://haku.helmet.fi/iii/encore/record/C__Rb2413925?lang=fin",
    "image": "https://armas.btj.fi/request.php?id=f55f7189859e3777&pid=9780006486114",
    "author": "Martin, George R. R."
  },


  {
    "available": true,
    "name": "Lies of the beholder",
    "name_link": "https://haku.helmet.fi/iii/encore/record/C__Rb2423310?lang=fin",
    "image": "https://armas.btj.fi/request.php?id=f55f7189859e3777&pid=9781473224964&qtype=m&ftype=06",
    "author": "Sanderson, Brandon"
  },
  {
    "available": true,
    "name": "The rise of Skywalker",
    "name_link": "https://haku.helmet.fi/iii/encore/record/C__Rb2421889?lang=fin",
    "image": "https://armas.btj.fi/request.php?id=f55f7189859e3777&pid=9781529124569&qtype=m&ftype=06",
    "author": "Carson, Rae"
  },
  {
    "available": true,
    "name": "The faceless old woman who secretly lives in your home",
    "name_link": "https://haku.helmet.fi/iii/encore/record/C__Rb2421729?lang=fin",
    "image": "https://armas.btj.fi/request.php?id=f55f7189859e3777&pid=9780356515076&qtype=m&ftype=06",
    "author": "Fink, Joseph"
  },
  {
    "available": true,
    "name": "Come tumbling down",
    "name_link": "https://haku.helmet.fi/iii/encore/record/C__Rb2418959?lang=fin",
    "image": "https://armas.btj.fi/request.php?id=f55f7189859e3777&pid=9780765399311&qtype=m&ftype=06",
    "author": "McGuire, Seanan"
  },
  {
    "available": true,
    "name": "Loki: where mischief lies",
    "name_link": "https://haku.helmet.fi/iii/encore/record/C__Rb2415718?lang=fin",
    "image": "https://armas.btj.fi/request.php?id=f55f7189859e3777&pid=9781789056211&qtype=m&ftype=06",
    "author": "Lee, Mackenzi"
  },

  {
    "available": true,
    "name": "Sinisten ruusujen tanssi",
    "name_link": "https://haku.helmet.fi/iii/encore/record/C__Rb2431511?lang=fin",
    "image": "https://armas.btj.fi/request.php?id=f55f7189859e3777&pid=9789528102892&qtype=m&ftype=06",
    "author": "Stipa, Anita"
  },
  {
    "available": true,
    "name": "Lenkkisukkamurhat",
    "name_link": "https://haku.helmet.fi/iii/encore/record/C__Rb2426173?lang=fin",
    "image": "https://armas.btj.fi/request.php?id=f55f7189859e3777&pid=9789528022411&qtype=m&ftype=06",
    "author": "Tavutlammi, Caj C."
  },
  {
    "available": true,
    "name": "Todellisesti, ja luonnollisella tavalla selitettyjä Kummitus-juttuja, kerroiltut tonttujen ja kummitusten uskomisen estäämiseksi",
    "name_link": "https://haku.helmet.fi/iii/encore/record/C__Rb2426127?lang=fin",
    "image": "https://armas.btj.fi/request.php?id=f55f7189859e3777&pid=9789527211571&qtype=m&ftype=06",
    "author": null
  },
  {
    "available": true,
    "name": "Lapiot käteen, tyttäret",
    "name_link": "https://haku.helmet.fi/iii/encore/record/C__Rb2426121?lang=fin",
    "image": "https://armas.btj.fi/request.php?id=f55f7189859e3777&pid=9789529425228&qtype=m&ftype=06",
    "author": null
  },
  {
    "available": true,
    "name": "Pikku piika",
    "name_link": "https://haku.helmet.fi/iii/encore/record/C__Rb2425383?lang=fin",
    "image": "https://armas.btj.fi/request.php?id=f55f7189859e3777&pid=9789528021681&qtype=m&ftype=06",
    "author": "Haataja, Airi"
  },
  {
    "available": true,
    "name": "Rankaisija",
    "name_link": "https://haku.helmet.fi/iii/encore/record/C__Rb2425298?lang=fin",
    "image": "https://armas.btj.fi/request.php?id=f55f7189859e3777&pid=9789527083130&qtype=m&ftype=06",
    "author": "Nenonen, Jari"
  },
  {
    "available": true,
    "name": "Veritorstai",
    "name_link": "https://haku.helmet.fi/iii/encore/record/C__Rb2425294?lang=fin",
    "image": "https://armas.btj.fi/request.php?id=f55f7189859e3777&pid=9789527349076&qtype=m&ftype=06",
    "author": "Katajamäki, Unto"
  },
  {
    "available": true,
    "name": "Tie ilmastonmuutokseen: päivän ja yön sanoja",
    "name_link": "https://haku.helmet.fi/iii/encore/record/C__Rb2424453?lang=fin",
    "image": "https://armas.btj.fi/request.php?id=f55f7189859e3777&pid=9789528018544&qtype=m&ftype=06",
    "author": "Huhta, Maria"
  },
  {
    "available": true,
    "name": "Vaihtuvat maisemat",
    "name_link": "https://haku.helmet.fi/iii/encore/record/C__Rb2424433?lang=fin",
    "image": "https://armas.btj.fi/request.php?id=f55f7189859e3777&pid=9789527342053&qtype=m&ftype=06",
    "author": "Wassenaar, Joop"
  },
  {
    "available": true,
    "name": "Eroon elävien joukosta: rikosromaani",
    "name_link": "https://haku.helmet.fi/iii/encore/record/C__Rb2423465?lang=fin",
    "image": "https://armas.btj.fi/request.php?id=f55f7189859e3777&pid=9789528108221&qtype=m&ftype=06",
    "author": "Kiiskinen, Juhani"
  },
];

export const book_lists = {
	classics: {
		0: books[0],
		1: books[1],
		2: books[2],
		3: books[3],
		4: books[4],
		5: books[5],
		6: books[6],
    7: books[7],
    8: books[8],
    9: books[9],
	},
	new: {
		10: books[10],
		11: books[11],
		12: books[12],
		13: books[13],
		14: books[14],
		15: books[15],
		16: books[16],
    17: books[17],
    18: books[18],
    19: books[19],
	},
	kids: {
    20: books[20],
    21: books[21],
    22: books[22],
    23: books[23],
    24: books[24],
    25: books[25],
    26: books[26],
    27: books[27],
    28: books[28],
    29: books[29],
  },
  series: {
    30: books[30],
    31: books[31],
    32: books[32],
  },
  fantasy: {
    33: books[33],
    34: books[34],
    35: books[35],
    36: books[36],
    37: books[37],
  },
  recommended: {
    38: books[38],
    39: books[39],
    40: books[40],
    41: books[41],
    42: books[42],
    43: books[43],
    44: books[44],
    45: books[45],
    46: books[46],
    47: books[47],
  },
};

